import * as React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router'
import { Redirect } from 'react-router-dom'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { getLink } from '../links'

interface AdminRouteProps {
  component: React.ComponentClass
  country: SiteCountry
  exact: boolean
  path: string
}

const RedirectAdminRoute: React.FC<AdminRouteProps> = props => {
  const { country, ...rest } = props

  return (
    <Route
      {...rest}
      render={renderProps => {
        const to = {
          pathname: getLink(country, 'admin'),
          state: { from: renderProps.location },
        }
        return <Redirect to={to} />
      }}
    />
  )
}

const mapStateToProps = (state: AppState) => ({
  country: state.locale.country,
})

export default connect(mapStateToProps)(RedirectAdminRoute)
